import posthog from 'posthog-js'

// Initialize PostHog
if (typeof window !== 'undefined') {
  posthog.init('phc_SksHJYlWOsM5QFBKM2IH3rJhfgHazi1nNbxxkokyLUS', {
    api_host: 'https://us.i.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: false, // We'll manually capture pageviews
    capture_pageleave: true,
  })
}

export default posthog